<ni-card
    *ngIf="options.useCard"
    [bgColor]="'info'"
    [outline]="true"
    class="info-card"
>
    <h6 class="mt-0 title">Active Flight Departments</h6>
    <div class="count">{{ totalCustomers }}</div>
    <small>Source: FuelerLinx &amp; Your Network</small>
    <mat-icon>person</mat-icon>
</ni-card>

<div *ngIf="!options.useCard">Flight Depts.: {{ totalCustomers }}</div>
